import React from "react";
import styles from "./sobre_mim_jefim_tatuador.module.scss";
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import FacebookIcon from "../../icons/facebookIcon.tsx";

const Sobre_mim_jefim_tatuador: React.FC = () => {

    return (
        <div className={styles.sobre_mim_jefim_tatuador}>
            {/* HEADER */}
            <div className={styles.header}>
                <Link to="/jefim_tatuador" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1 className="mb-0">Sobre mim</h1>
            </div>

            {/* CONTEÚDO */}
            <div className={styles.content}>
                <div className={styles.imageContainer}>
                    <img src={require("./src/img_sobremim.png")} alt="Jefim tatuador" />
                </div>
                <h2>Jefferson Cassimiro</h2>
                <p>
                    Tatuador há 7 anos, premiado nos maiores eventos do mundo, como Tattoo Week e The Best Electric Ink.
                    Especialista em anime, neotradicional, fine line e fine art, crio tatuagens autênticas e exclusivas que unem técnica, emoção e identidade.
                    Cada traço é pensado pra contar sua história na pele — porque arte de verdade não se copia, se vive.
                </p>
            </div>

            {/* FOOTER */}
            <div className={styles.footer}>
                <div className={styles.divSocials}>


                    <a href="https://wa.me/5517992752562?text=Olá, vim pelo link na bio e gostaria de mais informações..." target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><WhatsappIcon height="30" color="#ffffff" /></div>
                            <span>WhatsApp</span>
                        </div>
                    </a>
                    <a href="https://maps.app.goo.gl/UrU3jwZrUpWw4wBJ7" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><MapsIcon height="30" color="#ffffff" /></div>
                            <span>Localização</span>
                        </div>
                    </a>
                    <a href="https://www.instagram.com/jefim_tatuador?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><InstagramIcon height="26" color="#ffffff" /></div>
                            <span>Instagram</span>
                        </div>
                    </a>
                    <a
                        href="https://www.facebook.com/jefferson.igor.90"
                        target="_blank"
                    >
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}>
                                <FacebookIcon height="30" color="#ffffff" />
                            </div>
                            <span>Facebook</span>
                        </div>
                    </a>
                </div>
                <div className={styles.signature}>
                    Desenvolvido por{" "}
                    <a href="https://www.linksvibe.com.br" target="_blank" rel="noreferrer">
                        Links Vibe
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Sobre_mim_jefim_tatuador;
